/*eslint no-case-declarations: "off"*/

export const reducer = (state, action) => {
    switch (action.type) {
        case "CREATE_GLOBAL_SETTINGS":
            return {
                ...state,
                global: action.payload,
                pageList: [],
            };

        case "CREATE_PAGE_SETTINGS":
            return {
                ...state,
                pageList: [...state.pageList, action.payload],
            };

        case "UPDATE_PAGE_SETTINGS":
            const { currentPageIndex, settings } = action.payload;
            const currentState = state;
            currentState.pageList[currentPageIndex].settings = settings;
            return {
                ...state,
                pageList: [...state.pageList],
            };
        default:
            return state;
    }
};
